"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var relay_hooks_1 = require("relay-hooks");
exports.usePreloadedQueryOffline = function (loadQuery) {
    return relay_hooks_1.usePreloadedQuery(loadQuery);
};
